export default __webpack_public_path__ + "static/media/re-assign.1bf1a222.svg";